import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteSCRule, getSCRules } from "../redux/actions/AdminAction";
import styled from "@emotion/styled";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import { GET_SC_RULE_RESET } from "../Constants/Constants";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(id, created_at, rule_name, pccs, airlines, active) {
  return { id, created_at, rule_name, pccs, airlines, active };
}

export default function ScheduleChange(props) {
  const { decodedToken, checkUserPermission } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);

  const [row, setRow] = React.useState();
  const searchValue = React.useRef();
  const [deleteRuleId, setDeleteRuleId] = React.useState(null);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dialogOpen, setdialogOpen] = React.useState(false);

  const GetSCRules = useSelector((state) => state.GetSCRules);
  const { SCRulesInfo } = GetSCRules;

  const DeleteSCRule = useSelector((state) => state.DeleteSCRule);
  const { success, error } = DeleteSCRule;

  const handleDialogOpen = () => {
    setdialogOpen(true);
  };

  const handleDialogClose = () => {
    setdialogOpen(false);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  React.useEffect(() => {
    dispatch(getSCRules());
  }, [dispatch]);

  React.useEffect(() => {
    if (SCRulesInfo) {
      const newRows = Object.values(SCRulesInfo).map((value) => {
        return createData(
          value.pcc_rules_id,
          value.created_at,
          value.rule_name,
          value.pccs,
          value.airlines,
          value.active
        );
      });
      setRow(newRows);
    }
  }, [SCRulesInfo]);

  return (
    <React.Fragment>
      <Container>
        <Box>
          <Box sx={{ margin: 3, fontSize: 25 }}>
            Manage Schedule Change Rules
            <Divider sx={{ marginTop: 2 }}></Divider>
          </Box>
          <Box
            sx={{
              fontSize: 25,
              margin: 3,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {checkUserPermission(107, "can_add") && (
              <Button
                type="submit"
                size="small"
                onClick={() => {
                  dispatch({ type: GET_SC_RULE_RESET });
                  navigate("/scheduleChangeRules/new");
                }}
                sx={{
                  backgroundColor: "#282828",
                  color: "#ffffff",
                  width: "18vh",
                  borderRadius: 0,
                  fontSize: 16,
                  "&:hover": {
                    backgroundColor: "#282828",
                    color: "#ffffff",
                  },
                }}
              >
                Add new rule
              </Button>
            )}

            <TextField
              inputRef={searchValue}
              sx={{ width: "40vh" }}
              placeholder="Search"
              onChange={(e) => {
                dispatch(getSCRules(e.target.value));
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "5%",
        }}
      >
        <TableContainer
          component={Paper}
          sx={{
            width: "80%",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Creation Date</StyledTableCell>
                <StyledTableCell>Agencies</StyledTableCell>
                <StyledTableCell>PCCs</StyledTableCell>
                <StyledTableCell>Airlines</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Edit</StyledTableCell>
                <StyledTableCell>Delete</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row?.length > 0 ? (
                row.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {new Date(row.created_at).toLocaleString("en-GB", {
                        day: "numeric",
                        month: "short",   // gives "Sept"
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false     // 24-hour format
                      })}
                    </StyledTableCell>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      {row.rule_name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                      }}
                    >
                      {row.pccs && row.pccs.trim()
                        ? row.pccs
                          .split(" ")
                          .map(v => v.trim())
                          .filter(Boolean)
                          .join(", ")
                        : ""}

                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "160px",
                      }}
                    >
                      {row.airlines.trim()
                        ? row.airlines.split(",").join(", ")
                        : "All Airlines"}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      {row.active ? "Active" : "Inactive"}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        disabled={!checkUserPermission(107, "can_edit")}
                        sx={{
                          backgroundColor: !checkUserPermission(107, "can_edit")
                            ? "#D8D9DA"
                            : "#ffffff",
                          border: !checkUserPermission(107, "can_edit")
                            ? 0
                            : "1px solid black",
                          color: "black",
                          fontSize: 12,
                          height: "30px",
                        }}
                        onClick={() =>
                          navigate(`/scheduleChangeRules/${row.id}`)
                        }
                      >
                        Edit
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        textAlign: "left",
                      }}
                    >
                      <Button
                        disabled={!checkUserPermission(107, "can_delete")}
                        sx={{
                          backgroundColor: !checkUserPermission(
                            107,
                            "can_delete"
                          )
                            ? "#D8D9DA"
                            : "#d9534f",
                          color: "white",
                          fontSize: 12,
                          height: "30px",
                          "&:hover": {
                            backgroundColor: "#d9534f",
                            color: "white",
                          },
                        }}
                        onClick={() => {
                          setdialogOpen(true);
                          setDeleteRuleId(row.id);
                        }}
                      >
                        Delete
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow
                  style={{
                    wordWrap: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  <StyledTableCell
                    component="th"
                    colSpan={8}
                    scope="row"
                    style={{
                      textAlign: "center",
                      wordWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 15,
                    }}
                  >
                    No data found
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {success && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              Record deleted successfully
            </Alert>
          </Snackbar>
        )}
        {error && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          </Snackbar>
        )}
        <Dialog
          open={dialogOpen}
          onClose={handleDialogOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Opps!</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this rule?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>No</Button>
            <Button
              onClick={() => {
                dispatch(deleteSCRule(deleteRuleId)).then(() => {
                  dispatch(getSCRules());
                  setSnackOpen(true);
                  handleDialogClose();
                });
              }}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </React.Fragment>
  );
}
